// Documented image models. Subscription access and actual backend selection may vary.
export const CHATGPT_IMAGE_MODELS = [
  {
    "id": "gpt-image-2",
    "name": "GPT Image 2"
  },
  {
    "id": "gpt-image-2.5-flare",
    "name": "GPT Image 2.5 Flare"
  },
  {
    "id": "gpt-image-2.5-sunburst",
    "name": "GPT Image 2.5 Sunburst"
  },
  {
    "id": "gpt-image-1.5",
    "name": "GPT Image 1.5"
  },
  {
    "id": "gpt-image-1",
    "name": "GPT Image 1"
  },
  {
    "id": "gpt-image-1-mini",
    "name": "GPT Image 1 Mini"
  },
  {
    "id": "chatgpt-image-latest",
    "name": "ChatGPT Image Latest"
  },
  {
    "id": "gpt-image-2-2026-04-21",
    "name": "GPT Image 2 · 2026-04-21"
  },
  {
    "id": "gpt-image-2.5-flare-2026-09-08",
    "name": "GPT Image 2.5 Flare · 2026-09-08"
  },
  {
    "id": "gpt-image-2.5-sunburst-2026-09-08",
    "name": "GPT Image 2.5 Sunburst · 2026-09-08"
  }
] as const;
export type ChatGPTImageModel = typeof CHATGPT_IMAGE_MODELS[number]['id'];
export function chatGPTBackendModel(id = 'openai/chatgpt-image'): ChatGPTImageModel {
 const model = id === 'openai/chatgpt-image' ? 'gpt-image-2' : id.replace(/^openai\//, '');
 const entry = CHATGPT_IMAGE_MODELS.find(entry => entry.id === model);
 if (!entry) throw new Error('Unknown ChatGPT image model.');
 return entry.id;
}
export function chatGPTQualities(model: string): string[] {
 return model.startsWith('gpt-image-2.5-') ? ['low','medium','high','xhigh','max'] : ['low','medium','high'];
}
